import React from 'react';
import { assetHoldings } from '../../utils/portfolioData';
export function AssetPerformanceTable() {
  // Calculate total portfolio value for allocation
  const totalValue = assetHoldings.reduce((sum, asset) => sum + asset.spotAmount * asset.price, 0);
  const entryMultipliers: Record<string, number> = {
    BTC: 0.93,
    ETH: 1.02,
    SOL: 0.88,
    BNB: 0.97,
    USDT: 1.0
  };
  return <div className="glass-border rounded-[20px] overflow-hidden" data-id="element-16">
      <div className="p-6 border-b border-border-subtle" data-id="element-17">
        <h3 className="text-sm font-heading text-text-primary" data-id="element-18">
          Asset Performance
        </h3>
      </div>
      <div className="overflow-x-auto" data-id="element-19">
        <table className="w-full text-left border-collapse" data-id="element-20">
          <thead data-id="element-21">
            <tr className="border-b border-border-subtle" data-id="element-22">
              <th className="py-3 px-6 text-xs font-label text-text-secondary font-medium" data-id="element-23">
                Asset
              </th>
              <th className="py-3 px-6 text-xs font-label text-text-secondary font-medium text-right" data-id="element-24">
                Entry Price
              </th>
              <th className="py-3 px-6 text-xs font-label text-text-secondary font-medium text-right" data-id="element-25">
                Current Price
              </th>
              <th className="py-3 px-6 text-xs font-label text-text-secondary font-medium text-right" data-id="element-26">
                Quantity
              </th>
              <th className="py-3 px-6 text-xs font-label text-text-secondary font-medium text-right" data-id="element-27">
                P&L ($)
              </th>
              <th className="py-3 px-6 text-xs font-label text-text-secondary font-medium text-right" data-id="element-28">
                P&L (%)
              </th>
              <th className="py-3 px-6 text-xs font-label text-text-secondary font-medium" data-id="element-29">
                Allocation
              </th>
            </tr>
          </thead>
          <tbody data-id="element-30">
            {assetHoldings.map(asset => {
            const multiplier = entryMultipliers[asset.symbol] || 0.95;
            const entryPrice = asset.price * multiplier;
            const currentPrice = asset.price;
            const quantity = asset.spotAmount;
            const pnlAmount = (currentPrice - entryPrice) * quantity;
            const pnlPercent = (currentPrice - entryPrice) / entryPrice * 100;
            const value = quantity * currentPrice;
            const allocation = value / totalValue * 100;
            const isStablecoin = asset.symbol === 'USDT' || asset.symbol === 'USDC';
            return <tr key={asset.symbol} className="border-b border-border-subtle last:border-0 hover:bg-white/[0.02] transition-colors" data-id="element-31">
                  <td className="py-4 px-6" data-id="element-32">
                    <div className="flex items-center gap-3" data-id="element-33">
                      <img src={asset.logo} alt={asset.symbol} className="w-6 h-6 rounded-full" data-id="element-34" />
                      <div data-id="element-35">
                        <div className="text-sm font-medium text-text-primary" data-id="element-36">
                          {asset.symbol}
                        </div>
                        <div className="text-xs text-text-secondary" data-id="element-37">
                          {asset.name}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-right font-numbers text-sm text-text-secondary" data-id="element-38">
                    $
                    {entryPrice.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
                  </td>
                  <td className="py-4 px-6 text-right font-numbers text-sm text-text-primary" data-id="element-39">
                    $
                    {currentPrice.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
                  </td>
                  <td className="py-4 px-6 text-right font-numbers text-sm text-text-primary" data-id="element-40">
                    {quantity.toLocaleString(undefined, {
                  maximumFractionDigits: 4
                })}
                  </td>
                  <td className={`py-4 px-6 text-right font-numbers text-sm ${isStablecoin ? 'text-text-tertiary' : pnlAmount >= 0 ? 'text-success' : 'text-danger'}`} data-id="element-41">
                    {!isStablecoin && pnlAmount >= 0 ? '+' : ''}$
                    {isStablecoin ? '0.00' : pnlAmount.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
                  </td>
                  <td className={`py-4 px-6 text-right font-numbers text-sm ${isStablecoin ? 'text-text-tertiary' : pnlPercent >= 0 ? 'text-success' : 'text-danger'}`} data-id="element-42">
                    {!isStablecoin && pnlPercent >= 0 ? '+' : ''}
                    {isStablecoin ? '0.00' : pnlPercent.toFixed(2)}%
                  </td>
                  <td className="py-4 px-6" data-id="element-43">
                    <div className="flex items-center gap-2" data-id="element-44">
                      <div className="w-24 h-1.5 bg-background-elevated rounded-full overflow-hidden" data-id="element-45">
                        <div className="h-full bg-brand-purple rounded-full" style={{
                      width: `${allocation}%`
                    }} data-id="element-46" />
                      </div>
                      <span className="text-xs font-numbers text-text-secondary w-10 text-right" data-id="element-47">
                        {allocation.toFixed(1)}%
                      </span>
                    </div>
                  </td>
                </tr>;
          })}
          </tbody>
        </table>
      </div>
    </div>;
}